import { Icon as BlueIcon } from '@blueprintjs/core';
import { useContext, useEffect, useState as useClassicState } from 'react';

import SerachClearIcon from '@assets/svg/search-clear.svg';

import SerachIcon from '@assets/svg/table-search.svg';

import Rolling from '@assets/gif/rolling.gif';

import { useState } from '@hookstate/core';

import { useHistory } from 'react-router-dom';

import { ITaskRawQuery } from '@models/Task.model';

import {
  InfiniteData,
  useMutation,
  useQueryClient,
  UseQueryResult,
} from 'react-query';
import { useInView } from 'react-intersection-observer';

import { IPaginationResult } from '@models/Equipment.model';
import { IGetTasksCount } from '@services/queries/tasks/getTasksCount/getTasksCount';
import { NavigationContext } from '@layout/navigation/navigation';
import { createTask } from '@services/queries/tasks';
import { SortTasksTypes, TasksContext } from './Tasks.query';

import {
  Container,
  Content,
  Header,
  Title,
  Heading,
  Buttons,
  InputContainer,
  InputSearch,
  SearchIconContainer,
  SearchButton,
  SearchClear,
  TitleContainer,
  HeaderBottom,
  HeaderBottomLeft,
  LoadMore,
  LoadingText,
  LoadingImg,
  TabsContainer,
  Tabs,
  Indicator,
  LabelText,
  Label,
  Count,
  Back,
  ItemTab,
  CreateButton,
  EmptyPageWrapper,
  EmptyPageHeading,
  AssineeWrapper,
  AssineeImage,
  CreateButtonIcon,
  CreateButtonText,
} from './Tasks.styles';

import { CountLoading, TableContentLoading } from './Tasks.loading';
import { ColumnTitle, CreateTaskDialog, TaskRow } from './components';
import { DetailsDialog } from './components/DetailsDialog/DetailsDialog';

const CountComponent = ({ count }: { count?: number }) => {
  if (count !== undefined) {
    return <Count>{count}</Count>;
  }

  return <CountLoading />;
};

interface ITasksRaw {
  tasksQuery?: InfiniteData<IPaginationResult<ITaskRawQuery>>;
  tasksCountQuery?: UseQueryResult<IGetTasksCount, unknown>;
  fetchNextPage: () => void;
  isError?: boolean;
  isLoading?: boolean;
}

const TasksRaw = ({
  tasksQuery,
  fetchNextPage,
  isError,
  isLoading,
  tasksCountQuery,
}: ITasksRaw) => {
  const { search, status, assignedToMe, direction, sort } =
    useContext(TasksContext);
  const { userPicture } = useContext(NavigationContext);

  const { ref, inView } = useInView();

  const queryClient = useQueryClient();

  const [selectedTask, setSelectedTask] = useClassicState<ITaskRawQuery | null>(
    null,
  );

  const hasMore = tasksQuery
    ? tasksQuery.pages[tasksQuery.pages.length - 1].hasMore
    : false;

  const tasks = tasksQuery
    ? tasksQuery.pages
        .map(pageData => pageData.results)
        .reduce(function reduce(prev, next) {
          return prev.concat(next);
        })
    : [];

  useEffect(() => {
    if (inView && hasMore) fetchNextPage();
  }, [inView, hasMore]);

  const history = useHistory();

  const searchLocal = useState<string>('');
  const searchEdited = useState<boolean>(false);
  const openCreateTask = useState<boolean>(false);
  const openDialog = useState<boolean>(false);

  const createTaskMutation = useMutation(createTask, {
    onSuccess: async newTask => {
      setSelectedTask(newTask);
      openDialog.set(true);

      queryClient.invalidateQueries(['tasks']);
    },
  });

  const searchState = search.get() !== searchLocal.get() || searchEdited.get();
  const clearState =
    search.get() === searchLocal.get() &&
    searchLocal.get() !== '' &&
    !searchEdited.get();

  const callSearch = () => {
    search.set(searchLocal.get());
    searchEdited.set(false);
  };

  const clearSearch = () => {
    searchLocal.set('');
    search.set('');
    searchEdited.set(false);
  };

  const sortClick = (columnName: SortTasksTypes) => {
    if (sort.value === columnName) {
      if (direction.value === 'ASC') {
        direction.set('DESC');
      } else {
        sort.set(undefined);
        direction.set(undefined);
      }
    } else {
      sort.set(columnName);
      direction.set('ASC');
    }
  };

  const columnDirection = (columnName: SortTasksTypes) => {
    if (sort.value === columnName) {
      if (direction.value === 'ASC') {
        return 'down';
      }

      return 'up';
    }

    return undefined;
  };

  return (
    <Container>
      <Header>
        <HeaderBottomLeft>
          <TitleContainer>
            <Title>Tasks</Title>
          </TitleContainer>
        </HeaderBottomLeft>

        <TabsContainer>
          <Tabs>
            <ItemTab
              onClick={() => {
                history.push(`/tasks?tab=all`);
              }}
            >
              <Label>
                <LabelText isActive={status === 'all'}>All Tasks</LabelText>

                <CountComponent count={tasksCountQuery?.data?.all} />
              </Label>

              <Indicator isActive={status === 'all'} />
            </ItemTab>
            <ItemTab
              onClick={() => {
                history.push(`/tasks?tab=todo`);
              }}
            >
              <Label>
                <LabelText isActive={status === 'todo'}>To Do</LabelText>

                <CountComponent count={tasksCountQuery?.data?.todo} />
              </Label>

              <Indicator isActive={status === 'todo'} />
            </ItemTab>
            <ItemTab
              onClick={() => {
                history.push(`/tasks?tab=inprogress`);
              }}
            >
              <Label>
                <LabelText isActive={status === 'inprogress'}>
                  In Progress
                </LabelText>

                <CountComponent count={tasksCountQuery?.data?.inprogress} />
              </Label>

              <Indicator isActive={status === 'inprogress'} />
            </ItemTab>
            <ItemTab
              onClick={() => {
                history.push(`/tasks?tab=done`);
              }}
            >
              <Label>
                <LabelText isActive={status === 'done'}>Done</LabelText>

                <CountComponent count={tasksCountQuery?.data?.done} />
              </Label>

              <Indicator isActive={status === 'done'} />
            </ItemTab>
          </Tabs>
          <Back />
        </TabsContainer>

        <HeaderBottom>
          <div />
          <Buttons>
            <InputContainer>
              <SearchIconContainer>
                <img src={SerachIcon} alt="search" />
              </SearchIconContainer>
              <InputSearch
                placeholder="Search"
                value={searchLocal.get()}
                onChange={e => {
                  searchLocal.set(e.target.value);
                  searchEdited.set(true);

                  searchLocal.get().length < 1 && clearSearch();
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    callSearch();
                  }
                }}
                search={searchState}
                clear={clearState}
              />
              {searchState && (
                <SearchButton onClick={callSearch}>Search</SearchButton>
              )}
              {clearState && (
                <SearchClear onClick={clearSearch}>
                  <img src={SerachClearIcon} alt="clear" />
                </SearchClear>
              )}
            </InputContainer>
            <AssineeWrapper
              active={assignedToMe.value}
              onClick={() => {
                assignedToMe.set(!assignedToMe.value);
              }}
            >
              <AssineeImage src={userPicture} alt="User" />
              <span>Assigned to Me</span>
            </AssineeWrapper>
            <CreateButton
              onClick={() => {
                if (!createTaskMutation.isLoading) {
                  createTaskMutation.mutate({
                    title: 'New Task Title',
                    description: 'New Task Description',
                    status: 'todo',
                    priority: 'uncertain',
                  });
                }
              }}
            >
              <CreateButtonIcon>
                <BlueIcon icon="plus" color="#fff" />
              </CreateButtonIcon>
              <CreateButtonText>Add Task</CreateButtonText>
            </CreateButton>
            {/* <FilterContainer>
              <BlueIcon icon="filter" size={16} color="#C2CAF8" />
            </FilterContainer> */}
            {/* <MenuButton>
            <TasksMenu />
          </MenuButton> */}
          </Buttons>
        </HeaderBottom>
      </Header>

      {tasksQuery && tasks.length === 0 && (
        <EmptyPageWrapper>
          <EmptyPageHeading>There are no tasks on this tab!</EmptyPageHeading>
        </EmptyPageWrapper>
      )}

      {tasksQuery && (
        <Content>
          {tasks.length > 0 && (
            <Heading>
              <ColumnTitle
                label="Title"
                onClick={() => sortClick('t.title')}
                direction={columnDirection('t.title')}
              />
              <ColumnTitle
                label="Assginee"
                onClick={() => sortClick('u."name"')}
                direction={columnDirection('u."name"')}
              />
              <ColumnTitle
                label="Priority"
                onClick={() => sortClick('t.priority')}
                direction={columnDirection('t.priority')}
              />
              <ColumnTitle
                label="Due Date"
                onClick={() => sortClick('t."dueDate"')}
                direction={columnDirection('t."dueDate"')}
              />
              <ColumnTitle
                label="Status"
                onClick={() => sortClick('t.status')}
                direction={columnDirection('t.status')}
              />

              <div />
            </Heading>
          )}

          {tasks.map(task => {
            return (
              <TaskRow
                key={task.id}
                task={task}
                openTask={() => {
                  setSelectedTask(task);
                  openDialog.set(true);
                }}
              />
            );
          })}

          <LoadMore ref={ref}>
            {hasMore ? (
              <LoadMore>
                <LoadingText>Loading more</LoadingText>
                <LoadingImg src={Rolling} alt="loading" />
              </LoadMore>
            ) : (
              <div />
            )}
          </LoadMore>
        </Content>
      )}

      {isLoading && <TableContentLoading />}

      {isError && <div>error temporary</div>}

      {openCreateTask.value && (
        <CreateTaskDialog
          onClose={() => {
            openCreateTask.set(false);
          }}
          open={openCreateTask.value}
        />
      )}

      {openDialog.value && selectedTask && (
        <DetailsDialog
          open={openDialog.value}
          onClose={() => {
            openDialog.set(false);
          }}
          taskId={selectedTask.id}
        />
      )}
    </Container>
  );
};

export { TasksRaw };
